/* Dawn × noUiSlider 15 – dual-handle quantity slider ("Mengenstaffel") */
/* Optimized for performance - reduced latency */

(function() {
  'use strict';

  // Cache DOM queries
  let alertsHidden = false;
  
  // Debounce utility for performance
  function debounce(fn, delay) {
    let timer;
    return function(...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  // Hide cart alerts once, efficiently
  function hideAllCartAlerts() {
    if (alertsHidden) return;
    
    const alerts = document.querySelectorAll(
      '[role="alert"], .cart-item__error, .cart-item__error-text, ' +
      '.quantity__rules, .quantity__error, .product-form__error-message-wrapper'
    );
    
    alerts.forEach(el => {
      el.style.display = 'none';
      el.hidden = true;
    });
    
    alertsHidden = true;
  }

  // Initialize all sliders
  function initAllSliders() {
    const sliders = document.querySelectorAll('.qty-slider:not([data-initialized])');
    sliders.forEach(initSlider);
    hideAllCartAlerts();
  }

  function initSlider(root) {
    // Mark as initialized immediately to prevent double-init
    root.setAttribute('data-initialized', 'true');
    
    // Cache elements
    const rails   = root.querySelector('.qty-slider__rails');
    const num     = root.querySelector('.qty-slider__number');
    const numTo   = root.querySelector('.qty-slider__number--to');
    const tierBox = root.querySelector('.qty-slider__tier');
    const toggle  = root.querySelector('.qty-slider__tier-toggle');
    const hid     = root.querySelector('.qty-slider__hidden');

    if (!rails || !num || !hid) {
      console.warn('Missing required slider elements');
      return;
    }

    // Parse numeric limits once
    const min   = parseInt(root.dataset.min, 10) || 1;
    const max   = parseInt(root.dataset.max, 10) || 5000;
    const step  = parseInt(root.dataset.step, 10) || 1;
    const start = parseInt(hid.value, 10) || min;

    // Remove validation attributes that cause Dawn interference
    [num, numTo, hid].forEach(input => {
      if (input) {
        input.removeAttribute('required');
        input.setAttribute('data-slider-input', 'true');
      }
    });

    // Snap helpers
    const snap = v => Math.min(Math.max(Math.round(v / step) * step, min), max);
    const snapSlider = (v, isTier) => {
      const snapStep = isTier ? 25 : 10;
      return Math.min(Math.max(Math.round(v / snapStep) * snapStep, min), max);
    };

    // Create slider with optimized settings
    try {
      noUiSlider.create(rails, {
        start: [start, max],
        step: 1,
        range: { min, max },
        connect: true,
        animate: false, // Disable animation for snappier feel
        format: {
          to: v => Math.round(v),
          from: v => +v
        }
      });
    } catch (e) {
      console.error('Slider creation failed:', e);
      return;
    }

    // Silent update - no event triggering
    const silentUpdate = (input, value) => {
      if (input && input.value !== String(value)) {
        input.value = value;
      }
    };

    // Debounced cart update
    const updateCart = debounce(() => {
      alertsHidden = false;
      hideAllCartAlerts();
    }, 100);

    // Slider update handler - optimized
    rails.noUiSlider.on('update', (values) => {
      const left = parseInt(values[0], 10);
      const right = parseInt(values[1], 10);
      
      silentUpdate(num, left);
      silentUpdate(hid, left);
      
      if (toggle && toggle.checked && numTo) {
        silentUpdate(numTo, right);
      }
      
      updateCart();
    });

    // Handle snapping on slide
    rails.noUiSlider.on('slide', (values, handle) => {
      const isTier = toggle && toggle.checked;
      const left = parseInt(values[0], 10);
      const right = parseInt(values[1], 10);
      
      if (handle === 0) {
        const snapped = snapSlider(left, isTier);
        const currentRight = parseInt(rails.noUiSlider.get()[1], 10);
        const minRight = isTier ? Math.max(snapped * 1.3, snapped + 25) : currentRight;
        rails.noUiSlider.set([snapped, Math.max(minRight, currentRight)]);
      } else if (handle === 1 && isTier) {
        const snapped = snapSlider(right, true);
        const currentLeft = parseInt(rails.noUiSlider.get()[0], 10);
        const minRight = Math.max(currentLeft * 1.3, currentLeft + 25);
        rails.noUiSlider.set([currentLeft, Math.max(snapped, minRight)]);
      }
    });

    // Number input handlers
    num.addEventListener('change', (e) => {
      e.stopPropagation();
      const base = snap(parseInt(num.value, 10) || min);
      const isTier = toggle && toggle.checked;
      const other = parseInt(rails.noUiSlider.get()[1], 10);
      const rightVal = isTier ? Math.max(other, base * 1.3, base + 25) : max;
      rails.noUiSlider.set([base, rightVal]);
    });

    if (numTo) {
      numTo.addEventListener('change', (e) => {
        e.stopPropagation();
        if (!toggle || !toggle.checked) return;
        const base = parseInt(rails.noUiSlider.get()[0], 10);
        const inputVal = parseInt(numTo.value, 10) || base;
        const minHigh = Math.max(base * 1.3, base + 25);
        const high = snap(Math.max(inputVal, minHigh));
        rails.noUiSlider.set([base, high]);
      });
    }

    // Toggle handler
    if (toggle) {
      toggle.addEventListener('change', (e) => {
        e.stopPropagation();
        
        const isChecked = toggle.checked;
        if (tierBox) tierBox.hidden = !isChecked;
        root.classList.toggle('no-tier', !isChecked);
        
        const base = parseInt(rails.noUiSlider.get()[0], 10);
        
        if (isChecked) {
          const snappedBase = snapSlider(base, true);
          const target = snapSlider(Math.max(snappedBase * 1.3, snappedBase + 25), true);
          rails.noUiSlider.set([snappedBase, target]);
          silentUpdate(num, snappedBase);
          if (numTo) silentUpdate(numTo, target);
        } else {
          const snappedBase = snapSlider(base, false);
          rails.noUiSlider.set([snappedBase, max]);
          silentUpdate(num, snappedBase);
          if (numTo) silentUpdate(numTo, '');
        }
        
        updateCart();
      });
    }

    // Initial state
    if (tierBox) tierBox.hidden = true;
    root.classList.add('no-tier');

    return { slider: rails.noUiSlider, element: root };
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }

  // Handle dynamic cart updates
  document.addEventListener('cart:updated', () => {
    alertsHidden = false;
    initAllSliders();
  });

  // Expose for external use
  window.initQuantitySlider = initSlider;
})();
